import { z } from "zod";

export const validationHelper: z.ZodErrorMap = (issue) => {
	const input = (issue as { input?: unknown }).input;
	const expected = (issue as { expected?: string }).expected;

	if (issue.code === "invalid_type") {
		if (input === undefined || input === null) {
			switch (expected) {
				case "date":
				case "string":
				case "number":
				case "boolean":
					return { message: "Required" };

				default:
					break;
			}
		}
	}

	if (issue.code === "invalid_union") {
		return { message: "Required" };
	}

	return { message: issue.message ?? "Invalid value" };
};

z.config({ customError: validationHelper });

export const isValidValue = (value: any): boolean => value !== null && value !== undefined;
